import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  OnInit,
  QueryList,
  ViewChild,
  ViewChildren,
} from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { SelectItem, TabPanel, TabView } from 'primeng';
import { IInboxJob } from '../../interfaces/inbox-job';
import { InboxBackService } from '../../services';
import { InboxJobsService } from '../../services';
import { VmeInboxJobsService } from '../../services';
import { VmeJobsGridComponent } from './vme-jobs-grid.component';
import { VmeJobsTasksComponent } from './vme-jobs-tasks.component';
import { VmeJobsWaitingApprovalComponent } from './vme-jobs-waiting-approval.component';
import { Location } from '@angular/common';
import { OrganisationTypeEnum } from '../../enums/organisation-types';

@Component({
  selector: 'vme-jobs-inbox',
  templateUrl: './vme-jobs-inbox.component.html',
  styleUrls: ['./jobs-inbox.scss'],
})
export class VmeJobsInboxComponent implements OnInit, AfterViewInit {
  public inboxType_SupplierToBeConfirmed = 1;
  public inboxType_AwaitingStart = 2;
  public inboxType_CompletedJobs = 3;
  public inboxType_Combine = 4;
  public inboxType_JobsWaitingForApproval = 5;
  public inboxType_Live = 6;
  public inboxType_UrgentJobs = 7;
  public inboxType_ClosedJobs = 8;
  public inboxType_CancelledJobs = 9;
  public inboxType_GlobalFilter = 10;
  public inboxType_Deploy = 11;
  public liveTasks_InboxType_VME = 1;
  public inboxType_ExistingCapacity = 12;
  public vmeInboxUrl = '/app/vmeinbox';
  public stageId: number;
  public tabCombine: { selected: boolean } = {
    selected: false,
  };
  public tabDeploy: { selected: boolean } = {
    selected: false,
  };

  totalCount: number[] = [];

  showCombineTab: boolean = false;

  @ViewChildren('jobgrid')
  jobGrids: QueryList<VmeJobsGridComponent>;

  @ViewChild('jobtasks')
  jobTasks: VmeJobsTasksComponent;

  @ViewChild('jobwaitingforapproval')
  jobGridWaitingForApproval: VmeJobsWaitingApprovalComponent;

  public isLoaded: boolean = false;
  public jobIsSelected: boolean = false;
  public selecteditem: any;
  public selectedItemEC: any;
  public selectItemECJob: any;

  customers: SelectItem[];
  suppliers: SelectItem[];

  jobCounts = {
    awaitingStartCount: 0,
    additionalCostsRequestsCount: 0,
    cancelledCount: 0,
    completedCount: 0,
    jobsWaitingForApprovalCount: 0,
    liveNowCount: 0,
    urgentJobsCount: 0,
    closedCount: 0,
    cancelledJobsCount: 0,
    globalFilterCount: 0,
    deploymentCount: 0,
    existingCapacityCount: 0,
  };
  private inboxType: any;
  selectedTab = 11;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private location: Location,
    private inboxjobsService: InboxJobsService,
    private vmeInboxJobsService: VmeInboxJobsService,
    private inboxBackService: InboxBackService,
    private vmeInboxjobsService: VmeInboxJobsService,
    private cdr: ChangeDetectorRef,
  ) {}

  ngOnInit() {
    this.vmeInboxjobsService.getJobCounts().then((res) => {
      Object.keys(res).forEach((key) => {
        // Bit hacky, but deploymentCount comes back as zero and we populate elsewhere
        if (key !== 'deploymentCount') {
          this.jobCounts[key] = res[key];
        }
      });
    });

    this.updateCombineTabVisibility();

    this.vmeInboxjobsService.getCustomers().then((res) => {
      var l = [];
      if (res != null) res.forEach((item) => l.push({ label: item.name, value: item.id }));
      this.customers = l;
    });

    this.vmeInboxjobsService.getSuppliers().then((res) => {
      var l = [];
      if (res != null) res.forEach((item) => l.push({ label: item.name, value: item.id }));
      this.suppliers = l;
    });
  }

  ngAfterViewInit() {
    this.route.params.subscribe((params: Params) => {
      this.selectedTab = parseInt(params['inboxType']) || 11;
      this.stageId = params['stageId'];
    });
    this.route.queryParams.subscribe((params: Params) => {
      if (params['selectedTab']) {
        this.selectedTab = params['selectedTab'];
      }
    });
  }

  jobSelectionChanged(obj: IInboxJob) {
    let item = obj[0];
    let inboxType = obj[1];

    if (this.getTabByInboxType(inboxType).selected) {
      this.jobIsSelected = item != null;
      this.selecteditem = null;
      this.selectItemECJob = null;

      if (item != null) {
        // for EC Match tab, set the selectedItemEC so the relevant control is loaded in the template
        if (inboxType == this.inboxType_ExistingCapacity) {
          this.selectedItemEC = item;

          this.inboxjobsService.getJob(item.id).then((res) => {
            this.selectItemECJob = res;
          });
        } else {
          this.inboxjobsService.getJob(item.id).then((res) => {
            this.selecteditem = { job: res };
          });

          if (!item.clicked && this.inboxjobsService) {
            this.inboxjobsService.markJobAsClicked(item.id).then((res) => {
              if (res) {
                this.jobGrids.forEach((o) => {
                  if (o) o.markJobAsClicked(item.id);
                });
                this.jobGridWaitingForApproval?.markJobAsClicked(item.id);
              }
            });
          }
        }
      }
    }
  }

  onTaskChanged(item: any) {
    this.jobIsSelected = item != null;
    this.selecteditem = null;

    if (item != null) {
      this.inboxjobsService.getJob(item.jobId).then((res) => {
        this.selecteditem = { job: res, taskId: item.id };
      });
    }
  }

  totalCountChanged(inboxType, count) {
    this.totalCount[inboxType] = count;

    let inboxName = this.vmeInboxjobsService.getInboxName(inboxType);
    if (inboxName) {
      let jobCountKey = inboxName.slice(0, 1).toLowerCase() + inboxName.substring(1) + 'Count';
      this.jobCounts[jobCountKey] = count;
    }
  }

  updateCombineTabVisibility() {
    this.vmeInboxJobsService.getVmeInboxToCombine().then((count) => {
      this.showCombineTab = count > 0;

      if (this.tabCombine.selected && !this.showCombineTab) {
        this.tabCombine.selected = false;
        this.tabDeploy.selected = true;
        this.onTabChange(null);
      }
    });
  }

  onGridAction(updateTabIDs: number[]) {
    this.updateCombineTabVisibility();

    //update template grid's data
    this.jobGrids.forEach((o) => {
      if (o && (!updateTabIDs || updateTabIDs.find((p) => p == o.inboxType))) o.gridUpdate();
    });

    //update custom Grid Awaiting data
    if (!updateTabIDs || updateTabIDs.find((p) => p == this.inboxType_JobsWaitingForApproval))
      this.jobGridWaitingForApproval?.gridUpdate();

    //update custom tasks grid'd data
    if (this.jobTasks && (!updateTabIDs || updateTabIDs.find((p) => p == this.inboxType_Live)))
      this.jobTasks.gridUpdate();
  }

  onTabChange(event) {
    if (event?.index != null) {
      this.location.replaceState(this.vmeInboxUrl + '/' + this.selectedTab);
    }

    // DB: Not sure this is needed anymore
    // this.inboxBackService.setTab(this.getInboxTypeBySelectedTab());

    this.jobIsSelected = false;

    //deselect grid items on all tabs (that are loaded)
    this.jobGrids
      .filter((o) => {
        return o != null && o.isLoaded;
      })
      .forEach((o) => {
        o.deselectJobFromInbox();
      });
    if (this.jobGridWaitingForApproval != null && this.jobGridWaitingForApproval.isLoaded)
      this.jobGridWaitingForApproval.deselectJobFromInbox();

    if (this.jobTasks) this.jobTasks.deselectTask();
  }

  chooseItem(item: number) {
    this.selectedTab = item;
    this.updateQueryParam('selectedTab', item.toString());
  }

  updateQueryParam(paramName: string, paramValue: string) {
    // Get the current route's queryParams
    let queryParams = { ...this.route.snapshot.queryParams };

    // Update or set the query parameter
    queryParams[paramName] = paramValue;

    // Use navigate to update the URL without reloading the page
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: queryParams,
      // Preserve the existing path parts of the URL.
      queryParamsHandling: 'merge',
    });
  }

  private getTabByInboxType(inboxType: any) {
    return { selected: true };
  }

  protected readonly OrganisationTypeEnum = OrganisationTypeEnum;
}
